import React from 'react';
import axios from 'axios';

const Logout = ({ onLogout }) => {
  const handleLogout = () => {
    const token = localStorage.getItem('auth_token');

    axios.post('http://127.0.0.1:8000/api/logout', {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    })
    .then(() => {
      localStorage.removeItem('auth_token');
      onLogout();
    })
    .catch(err => console.error('Logout error:', err));
  };

  return <button className="btn btn-warning mb-3" onClick={handleLogout}>Logout</button>;
};

export default Logout;
